import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';

import { ArticleDetailComponent } from './components/article-detail/article-detail.component';
import { ArticleListComponent } from './components/article-list/article-list.component';
import { CategoryComponent } from './components/category/category.component';
import { HomeComponent } from './components/home/home.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LEARNING_HUB_CATEGORY_PATH, LEARNING_HUB_SEARCH_PATH } from './definitions/learning-hub.constants';
import { LearningHubLegacyKind, LearningHubLegacyRedirectGuard } from './guards/learning-hub-legacy-redirect.guard';

const legacy = (kind: LearningHubLegacyKind): Partial<Route> => ({
  canActivate: [LearningHubLegacyRedirectGuard],
  data: { legacy: kind }
});

/**
 * Mounted at /learning-hub (see landing.routing.ts). Canonical URLs (the language is a query param, except in
 * articles where it is part of the slug URL like in the WordPress):
 *   /learning-hub?lang=es                              home (sections + staff pick)
 *   /learning-hub/category/:parent?lang=es             top-level section
 *   /learning-hub/category/:parent/:child?lang=es      subsection
 *   /learning-hub/search?lang=es&q=..&tag=..           search / tag results
 *   /learning-hub/:lang/:slug                          article
 * Old WordPress URLs work under the same path with /learning-hub in front (LearningHubLegacyRedirectGuard):
 *   /category/<nicename>[/<nicename>], /:lang/category/..., /tag/<tag>, /:lang/tag/<tag>, /:lang (old home),
 *   /<slug> (article in any language). The static `category`/`search`/`tag` paths go before `:lang/:slug`.
 */
const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', component: HomeComponent, ...legacy('home') },
      { path: LEARNING_HUB_SEARCH_PATH, component: ArticleListComponent },
      { path: `${LEARNING_HUB_CATEGORY_PATH}/:parent`, component: CategoryComponent, ...legacy('category') },
      { path: `${LEARNING_HUB_CATEGORY_PATH}/:parent/:child`, component: CategoryComponent, ...legacy('category') },
      { path: 'tag/:tag', component: ArticleListComponent, ...legacy('tag') },
      { path: `:lang/${LEARNING_HUB_CATEGORY_PATH}/:parent`, component: CategoryComponent, ...legacy('category') },
      { path: `:lang/${LEARNING_HUB_CATEGORY_PATH}/:parent/:child`, component: CategoryComponent, ...legacy('category') },
      { path: ':lang/tag/:tag', component: ArticleListComponent, ...legacy('tag') },
      { path: ':lang/:slug', component: ArticleDetailComponent },
      { path: ':slug', component: ArticleDetailComponent, ...legacy('slug') }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LearningHubRoutingModule {}
